import React, { useState } from "react";
import ButtonTag from "../../../reusebale/button";
import ParagraphTag from "../../../reusebale/Paragraph";
import PropertySuccessPopup from "../../../popup/propertySuccess";
import db from "../../../../db/index.json";
import Myloader from "../../../reusebale/myLoader";
import { useSelector } from "react-redux";
import BaseUrl from "../../../../constants/BaseUrl";
import { ShowError } from "../../../../utils/ToasFunction";

const Overview = ({ formFields, onCrateSuccess, onBackHome }) => {
  const { loginSuccess } = useSelector((state) => state.auth);

  const [loader, setLoader] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const CreateRequestHandler = () => {
    setLoader(true);
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${loginSuccess?.token}`);

    // Filter out tenants who have neither email nor SMS selected
    const filteredTenantList = formFields.tenantList.filter(
      (tenant) => tenant.emailSelect || tenant.numberSelect
    );

    const raw = JSON.stringify({
      landlordId: loginSuccess.user._id,
      title: formFields.title,
      description: formFields.description,
      tenantList: filteredTenantList,
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(`${BaseUrl}api/broadcast/createBroadCast`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "Success") {
          setLoader(false);
          onCrateSuccess();
          setShowSuccess(true);
        } else {
          setLoader(false);
          ShowError("Oops! Something went wrong. Please try again later.");
        }
      })
      .catch((error) => console.error(error));
  };

  const closePopup = () => {
    setShowSuccess(false);
    onBackHome();
    // dispatch(DataAction.ChangeBroadcastCurrentStep(1))
  };

  return (
    <div className="w-[95%] mx-auto h-full">
      <div className="text-center h-[10%] flex flex-col justify-center">
        <ParagraphTag
          content="Overview"
          classes="text-darkColor font-popinsSemiBold text-base 2xl:text-lg"
        />
        <ParagraphTag
          content="Please ensure all information is accurate before creating the request."
          classes="text-[#686868] font-popinsRegular text-xs"
        />
      </div>
      <div className="overflow-y-scroll h-[80%] panelScroll px-1">
        <div className="text-center flex flex-col justify-center">
          <ParagraphTag
            content="Title"
            classes="text-darkColor font-popinsSemiBold text-base"
          />
          <div>
            <ParagraphTag
              content={formFields?.title}
              classes="text-[#686868] font-popinsRegular text-xs"
            />
          </div>
        </div>
        <div className="text-center flex flex-col justify-center w-[90%] mx-auto pt-3">
          <ParagraphTag
            content="Description"
            classes="text-darkColor font-popinsSemiBold text-base"
          />
          <div>
            <ParagraphTag
              content={formFields?.description}
              classes="text-[#686868] font-popinsRegular text-xs line-clamp-3 pt-1"
            />
          </div>
        </div>
        <div className="flex flex-wrap w-full mt-6" id="gk-cards">
          {formFields?.tenantList?.map((item) => {
            // Only show tenants who have at least one notification method selected
            if (item.emailSelect || item.numberSelect) {
              return (
                <div className="w-[23%] flex mr-[2%] mt-1" key={item._id}>
                  <div className="text-center pt-2 px-1 ">
                    <ParagraphTag
                      content={`TEN-${item?._id?.slice(0, 10)}`}
                      classes="font-popinsRegular text-xs text-[#686868]"
                    />
                    <ParagraphTag
                      content={`${item?.firstName} ${item?.lastName}`}
                      classes="text-darkColor font-popinsSemiBold text-sm"
                    />
                    <div className="flex justify-between w-full pt-1">
                      <div className="flex w-[49%] items-center">
                        <input
                          checked={item?.emailSelect}
                          disabled
                          type="checkbox"
                          className="w-3 h-3 bg-bgColor rounded-sm cursor-pointer"
                        />
                        <ParagraphTag
                          content="email"
                          classes="text-[#686868] text-xs pl-1 font-popinsRegular"
                        />
                      </div>
                      <div className="flex w-[49%] items-center justify-end">
                        <input
                          checked={item?.numberSelect}
                          disabled
                          type="checkbox"
                          className="w-3 h-3 bg-bgColor rounded-sm cursor-pointer"
                        />
                        <ParagraphTag
                          content="SMS"
                          classes="text-[#686868] text-xs pl-1 font-popinsRegular"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              );
            }
            return null;
          })}
        </div>
      </div>
      <div className="h-[10%] flex justify-center">
        <div className="w-[50%]">
          {loader ? (
            <div className="flex justify-center items-center">
              <Myloader />
            </div>
          ) : (
            <ButtonTag
              onSubmit={() => {
                if (formFields.title === "") {
                  ShowError("Title is required");
                } else if (formFields.description === "") {
                  ShowError("Description is required");
                } else if (formFields.tenantList.length === 0) {
                  ShowError("Tenant is required");
                } else {
                  // Check if at least one tenant has email or SMS selected
                  const validTenants = formFields.tenantList.filter(
                    (tenant) => tenant.emailSelect || tenant.numberSelect
                  );
                  if (validTenants.length === 0) {
                    ShowError(
                      "Please select at least one notification method for at least one tenant"
                    );
                  } else {
                    CreateRequestHandler();
                  }
                }
              }}
              name="Submit"
              classes="text-base text-center bg-themeColor text-white"
            />
          )}
        </div>
      </div>
      {showSuccess && (
        <PropertySuccessPopup
          succMessage={`Broadcast request created successfully`}
          onClose={closePopup}
        />
      )}
    </div>
  );
};

export default Overview;
